module.exports = __webpack_public_path__ + "img/collaborators@2x.083d1f82.png";